import { LaravelResponse, keyToUrl } from "@dgs/core";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { SidebarResource } from "../types/sidebar";

const indexKey = ["sidebar"];

export const sidebarService = {
	indexKey,
	index: () => axios.get<LaravelResponse<SidebarResource>>(keyToUrl(indexKey)),
};

export const useSidebarData = () => {
	const { data, ...rest } = useQuery({
		queryKey: sidebarService.indexKey,
		queryFn: () => sidebarService.index().then((r) => r.data.data),
	});

	return {
		sidebarData: data,
		...rest,
	};
};
